module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('header', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "search flex-1",
    on: {
      "click": _vm.showSearch
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo_sousuo"
  }), _vm._v(" "), _c('form', {
    staticClass: "flex-1 pl5",
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchText),
      expression: "searchText",
      modifiers: {
        "trim": true
      }
    }],
    ref: "ipt",
    staticClass: "flex-1",
    attrs: {
      "type": "search",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchText.length > 0),
      expression: "searchText.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.searchText = ''
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cancle",
    on: {
      "click": function($event) {
        _vm.$emit('searchHide');
        _vm.$store.commit('showIsTab');
        _vm.searchText = ''
      }
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historySearchArr.length > 0),
      expression: "historySearchArr.length>0"
    }],
    staticClass: "history-search"
  }, [_c('div', {
    staticClass: "flex his-head vux-1px-b "
  }, [_c('span', [_vm._v("历史搜索")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": _vm.delSearch
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "his-box text-l flex"
  }, _vm._l((_vm.searchList), function(item) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.onSubmit(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91f16a6a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/search.vue
// module id = 605
// module chunks = 0